import React from 'react';

export default () => <div>
  <div style={{ display:'block', clear:'both' }} />
</div>